import { LoginDialog } from 'src/components/organisms/login/LoginDialog';

export const Login = () => {
  return <LoginDialog open={true} handleClose={() => {}} flatMode />;
};
